import {Model} from "ords/dist/model/model";
// marked for deletion
export class AssignmentStatusLog extends Model {
    getStatus(status){
        switch (status){
            case 0:
                return 'Ingeleverd';
            case 1:
                return 'Goed gekeurd';
            case 2:
                return 'Heropent';
            default:
                return null;
        }
    }
}

export const AssignmentStatusLogModelConfig = {
    name: 'assignmentStatusLog',
    model: AssignmentStatusLog,
    relation: [
        {name: 'user', model_name: 'user', type: 'hasOne'},
    ]
}
